import { render, staticRenderFns } from "./WebPhone.vue?vue&type=template&id=409c0310"
import script from "./WebPhone.vue?vue&type=script&lang=js"
export * from "./WebPhone.vue?vue&type=script&lang=js"
import style0 from "./WebPhone.vue?vue&type=style&index=0&id=409c0310&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports